// Custom.js

/* Shoplift PDP link fix (shared Shoplift-aware URL helper).
   Shoplift's own script only evaluates a visitor's test assignment and
   redirects once, at real full-page-load time (it lives outside Barba's
   swapped container and never re-executes on a client-side transition).
   So a visitor already bucketed into the "New Bundle PDP" test never got
   their assigned view=bundle-test-non-contr-new template on an in-app
   (Barba) navigation into a product page -- only a hard reload re-ran
   Shoplift's init/redirect flow.
   Shoplift's assignment is already resolved and available synchronously
   on every page load (confirmed even on the homepage, before ever
   touching a product page) via window.shopliftInstance.testConfigs and
   window.shopliftInstance.state.essential.visitorTests. So instead of
   re-invoking Shoplift after a Barba transition -- which can call
   window.location.assign() and cause a visible second reload --
   window.mugsyShopliftAwareUrl(url) below rewrites a product URL to
   already carry the correct view= before the visitor ever navigates, so
   Barba fetches the correctly-templated page on the very first click.
   Used for rewriting <a href> product links (below) AND wrapped around
   the inline barba.go(...) call in the shared product-card Alpine
   component (snippets/card_product-card.liquid and
   card_product-card-redesign.liquid) -- that click handler builds its
   own URL inline and never touches an <a href>, so the anchor rewrite
   alone can't reach it; it needs the same helper applied at the point it
   calls barba.go().
   Control-bucketed visitors are left untouched: Shoplift itself never
   redirects them (considerRedirect returns false for isControl
   hypotheses), so the default template is already correct for them. */
(function () {
  "use strict";

  function getAssignedNonControlAffix() {
    try {
      var inst = window.shopliftInstance;
      if (!inst || !Array.isArray(inst.testConfigs)) return null;
      if (!inst.state || !inst.state.essential) return null;
      var visitorTests = inst.state.essential.visitorTests || [];
      if (!Array.isArray(visitorTests)) return null;

      for (var i = 0; i < inst.testConfigs.length; i++) {
        var test = inst.testConfigs[i];
        if (!test || !Array.isArray(test.hypotheses)) continue;

        var assignment = null;
        for (var j = 0; j < visitorTests.length; j++) {
          var vt = visitorTests[j];
          if (vt && vt.testId === test.id) { assignment = vt; break; }
        }
        if (!assignment || assignment.isInvalid) continue;

        var hypothesis = null;
        for (var k = 0; k < test.hypotheses.length; k++) {
          var h = test.hypotheses[k];
          if (h && h.id === assignment.hypothesisId) { hypothesis = h; break; }
        }
        if (!hypothesis || hypothesis.isControl) continue;
        if (hypothesis.affix) return hypothesis.affix;
      }
    } catch (_) { /* Shoplift unavailable or shape changed -- do nothing */ }
    return null;
  }

  /* Shared helper: given a product URL (absolute or relative), returns
     the Shoplift-aware version -- appends view=<affix> when this visitor
     is assigned to a non-control hypothesis and the URL doesn't already
     carry a view= param. Returns the URL UNCHANGED in every other case
     (no Shoplift instance, control bucket, cross-origin, non-product
     path, or a view= already present). Never navigates, never calls into
     Shoplift itself -- read-only. Exposed on window so both the anchor
     rewrite below and the product-card Alpine click handler (Liquid
     snippets) can call the same logic. */
  function mugsyShopliftAwareUrl(rawUrl) {
    if (!rawUrl) return rawUrl;
    try {
      var affix = getAssignedNonControlAffix();
      if (!affix) return rawUrl;

      var url = new URL(rawUrl, window.location.origin);
      if (url.origin !== window.location.origin) return rawUrl;
      if (url.pathname.indexOf("/products/") === -1) return rawUrl;
      if (url.searchParams.has("view")) return rawUrl;

      url.searchParams.set("view", affix);

      var isAbsolute = /^https?:\/\//i.test(rawUrl);
      return isAbsolute ? url.toString() : url.pathname + url.search + url.hash;
    } catch (_) {
      return rawUrl;
    }
  }
  window.mugsyShopliftAwareUrl = mugsyShopliftAwareUrl;

  function rewriteProductLinks() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute("href");
      if (!href) continue;
      var rewritten = mugsyShopliftAwareUrl(href);
      if (rewritten !== href) a.setAttribute("href", rewritten);
    }
  }

  function runOnce() {
    try { rewriteProductLinks(); } catch (_) { /* no-op */ }
  }

  runOnce();
  document.addEventListener("pageFullyLoaded", runOnce);
})();
